var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("h1", { staticClass: "title is-4 has-text-primary" }, [
        _vm._v("\n    Auto Facturas\n  ")
      ]),
      _c("AppPagination", {
        staticClass: "is-centered",
        attrs: {
          "current-page": _vm.currentPage,
          "buttons-max": _vm.buttonsMax,
          "pages-total": _vm.totalPages
        },
        on: { change: _vm.goToPage }
      }),
      _c("table", { staticClass: "table is-fullwidth" }, [
        _vm._m(0),
        _c(
          "tbody",
          [
            _vm.isLoading
              ? _c("tr", [_vm._m(1)])
              : [
                  _vm.invoices.length === 0
                    ? _c("tr", [
                        _c(
                          "td",
                          { staticClass: "empty", attrs: { colspan: "7" } },
                          [_vm._v("\n            Sin datos\n          ")]
                        )
                      ])
                    : _vm._e(),
                  _vm._l(_vm.invoices, function(invoice, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [
                        _vm._v(
                          "\n            " +
                            _vm._s(invoice.voucherSeries) +
                            "\n            -\n            " +
                            _vm._s(invoice.voucherConsecutive) +
                            "\n          "
                        )
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm._f("toHumanDate")(invoice.voucherDate))
                        )
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toCurrency")(
                              invoice.voucherTotal,
                              invoice.voucherCurrency
                            )
                          )
                        )
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.voucherTypeLabel(invoice.voucherType))
                        )
                      ]),
                      _c("td", [
                        _c(
                          "div",
                          { staticClass: "buttons" },
                          [
                            _c(
                              "RouterLink",
                              {
                                staticClass: "button is-info",
                                attrs: {
                                  to: {
                                    name: "InvoiceDetail",
                                    params: { uuid: invoice.id }
                                  }
                                }
                              },
                              [_c("BIcon", { attrs: { icon: "pencil" } })],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  })
                ]
          ],
          2
        )
      ]),
      _c("AppPagination", {
        staticClass: "is-centered",
        attrs: {
          "current-page": _vm.currentPage,
          "buttons-max": _vm.buttonsMax,
          "pages-total": _vm.totalPages
        },
        on: { change: _vm.goToPage }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Folio")]),
        _c("th", [_vm._v("Fecha")]),
        _c("th", [_vm._v("Total")]),
        _c("th", [_vm._v("Tipo")]),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "is-loading", attrs: { colspan: "8" } }, [
      _c("a", { staticClass: "button is-loading is-fullwidth" }, [
        _vm._v("\n            Cargando..\n          ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }